<template>
    <b-modal
        size="md"
        ref="modal"
        button-size="sm"
        :busy="false"
        :no-close-on-esc="true"
        :hide-header-close="false"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :ok-disabled="true"
        :title="$t('people.uploads')"
        @close="$router.push({ path: '/v2/people/list' })"
    >
        <h6>{{ $t('people.selectUpload') }}</h6>

        <b-list-group flush>
            <b-list-group-item button @click="onClickUsersUploadHandler">
                <i class="fas fa-user-plus btn-uploads"></i>
                {{ $t('administrator.users') }}
            </b-list-group-item>
            <b-list-group-item button @click="onClickFeedbacksUploadHandler">
                <i class="fas fa-comment btn-uploads"></i>
                {{ $t('feedbacks.feedbacks') }}
            </b-list-group-item>
            <b-list-group-item button @click="onClickPdisUploadHandler">
                <i class="fas fa-line-chart btn-uploads"></i>
                {{ $t('pdis.pdis') }}
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>

<script>
import { onlyAdministratorFunctionAlert } from '../../alerts'
import { validationMixin } from 'vuelidate'
import notification from '@/lib/notification'

notification.init()

export default {
    name: 'UploadsModal',
    props: {
        canUploadUsers: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [validationMixin],
    mounted() {
        if (this.canUploadUsers) {
            this.$refs.modal.show()
        } else {
            this.handlerUserWithoutAuthorization()
        }
    },
    methods: {
        onClickUsersUploadHandler() {
            if (this.canUploadUsers) {
                this.$router.push({ path: '/v2/people/list/upload-users' })
            } else {
                this.onlyAdministratorFunction()
            }
        },
        onClickPdisUploadHandler() {
            if (this.canUploadUsers) {
                this.$router.push({ path: '/v2/people/list/upload-pdis' })
            } else {
                this.onlyAdministratorFunction()
            }
        },
        onClickFeedbacksUploadHandler() {
            if (this.canUploadUsers) {
                this.$router.push({ path: '/v2/people/list/upload-feedbacks' })
            } else {
                this.onlyAdministratorFunction()
            }
        },
        routerBack() {
            this.$router.back(-1)
        },
        handlerUserWithoutAuthorization() {
            return onlyAdministratorFunctionAlert().then(() => this.routerBack())
        },
    },
}
</script>
<style lang="scss" scope>
.list-group-flush .list-group-item {
    border: 0;
    padding: 0.5rem 0 0 0;
}
.btn-uploads {
    padding-right: 8px;
}
</style>
